import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import Card from "components/card";
import PopupButton from "components/button/PopupButton";
import CrudOption from "components/dropdown/crudoption";
import PurchaseOrderForm from "./PurchaseOrderForm";
import { handleTableChange } from "../../../../utils";
import { MODULE_PURCHASE_ORDER } from "variables/modules";
import {
	getPurchaseOrderList,
	doPurchaseOrderDelete,
	doPurchaseOrderReset,
} from "../../../../redux/purchaseorder/purchaseOrderState";
import SearchFilter from "components/search/SearchFilter";

const PurchaseOrderTable = ({ }) => {
	const dispatch = useDispatch();

	const recordList = useSelector((state) =>  state.purchaseOrder.purchaseOrderList?.items);
	const pagination = useSelector((state) => state.purchaseOrder.purchaseOrderList?.pagination);
	const filters = useSelector((state) => state.purchaseOrder.purchaseOrderList?.filters);
	const currentUserId = useSelector((state) => state.auth.user?.id);
	
	const doSearch = (filters) => dispatch(getPurchaseOrderList(filters));
	const doDelete = (recordId) => dispatch(doPurchaseOrderDelete(recordId));
	const doRecordReset = () => dispatch(doPurchaseOrderReset());

	const columns = [
		{
			title: "PO Number",
			dataIndex: "por_number",
			key: "por_number",
			width: "15%",
			render: (por_number) => <span>{por_number}</span>,
		},
		{
			title: "Vendor",
			dataIndex: "vendor_name",
			key: "vendor_name",
			width: "20%",
			render: (vendor_name) => <span>{vendor_name}</span>,
		},
		{
			title: (
				<>
					<div>Purchase Date /</div>
					<div>Acquired Date</div>
				</>
			),
			key: "purchase_info",
			width: "15%",
			render: (_, record) => (
				<>
					<div>{record?.por_purchase_date || "-"}</div>
					<div>{record?.por_acquired_date || "-"}</div>
				</>
			),

		},
		{
			title: "Total Items",
			dataIndex: "total_items_quantity",
			key: "total_items_quantity",
			width: "8%",
			render: (qty) => <span>{qty}</span>,
		},
		{
			title: "Total Amount",
			dataIndex: "por_total_amount",
			key: "por_total_amount",
			width: "15%",
			render: (amount, record) => (
				<span>
					{record.currency_code || "PHP"}{" "}
					{Number(amount || 0).toLocaleString(undefined, {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})}
				</span>
			),
		},
		{
			title: "Status",
			dataIndex: "approval_status_name",
			key: "approval_status_name",
			width: "10%",
			render: (approval_status_name) => <span>{approval_status_name}</span>,
		},
		{
			title: "Delivery Status",
			dataIndex: "delivery_status_name",
			key: "delivery_status_name",
			width: "12%",
			render: (delivery_status_name) => <span>{delivery_status_name}</span>,
		},
		{
			title: "Payment Status",
			dataIndex: "payment_status_name",
			key: "payment_status_name",
			width: "12%",
			render: (payment_status_name) => <span>{payment_status_name}</span>,
		},
		{
			title: (
				<PopupButton id="add_purchase_order" title="Add Purchase Order" label="Add" btnClass="btn-small" modalWidth={1200} action="add" moduleId={MODULE_PURCHASE_ORDER}>
					<PurchaseOrderForm recordId={0} mode="edit" />
				</PopupButton>
			),
			dataIndex: "por_id",
			key: "por_id",
			width: "12%",
			render: (_, record) => {
				const isDraft = record.approval_status_name === "Draft";
				const isOwner = Number(record.created_by) === Number(currentUserId);

				return (
					<CrudOption
						recordId={record.por_id}
						baseRoute="/console/purchase-orders"
						allowView={!isDraft}
						allowEdit={isDraft}
						allowDelete={isOwner}
						deleteHandler={doDelete}
						viewHandler={(recordId) => (
							<PurchaseOrderForm
								recordId={recordId}
								mode="view"
							/>
						)}
						title="Edit Purchase Order"
						editHandler={(recordId) => (
							<PurchaseOrderForm
								recordId={recordId}
								mode="edit"
							/>
						)}
						closeHandler={doRecordReset}
					/>
				);
			}
		},
	];

	useEffect(() => {
		dispatch(getPurchaseOrderList({
			paginate: pagination.per_page,
		})
	)}, [dispatch, pagination.per_page]);

	return (
		<Card extra={"w-full h-full p-4"}>
			<div className="py-2">
				<SearchFilter
					placeholder="Search by PO Number, Vendor Name or Status"
					searchHandler={doSearch}
					filters={filters}
					pagination={pagination}
				/>
			</div>
			<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<Table
					dataSource={recordList}
					columns={columns}
					rowKey={(record) => record.por_id}
					pagination={{
						...pagination,
						showTotal: (total, range) =>
							`${range[0]} - ${range[1]} of ${total} records`,
					}}
					onChange={handleTableChange(doSearch, filters)}
				/>
			</div>
		</Card>
	);
};

export default (PurchaseOrderTable);